import { render, staticRenderFns } from "./FooterBlog.vue?vue&type=template&id=2075c8de&scoped=true"
import script from "./FooterBlog.vue?vue&type=script&lang=js"
export * from "./FooterBlog.vue?vue&type=script&lang=js"
import style0 from "./css/footerBlog.css?vue&type=style&index=0&id=2075c8de&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2075c8de",
  null
  
)

export default component.exports